import ApiClient from './ApiClient';

class LeadSourcesAPI extends ApiClient {
  constructor() {
    super('lead_sources', { accountScoped: true });
  }
}

export default new LeadSourcesAPI();
